import PropTypes from 'prop-types';

export const props = {
  disabled: PropTypes.bool,
};
